import jobItemBorderClasses from "./JobItemBorderClasses";

const setPinnedJobsSection = () => {
   const pinnedJobs = JSON.parse(localStorage.getItem('pinnedJobs')) || [];
   const pinnedJobItems = [...document.querySelectorAll('[data-js-pinned-job-item]')];
   const noPinnedJobsSection = document.querySelector('[data-js-no-pinned-jobs-section]');
   const newArray = [];
   const totalItems = pinnedJobs.length;
   if (noPinnedJobsSection) {
      noPinnedJobsSection.classList.add('hidden');
   }
   pinnedJobItems.forEach(pinnedJobItem => {
      pinnedJobItem.classList.add('hidden');
      if (pinnedJobs.includes(pinnedJobItem.dataset.jsPinnedJobItem)) {
         newArray.push(pinnedJobItem);
      }
   });
   let orderSetting = 1;
   pinnedJobs.forEach(pinnedJobId => {
      newArray.forEach(newArrayItem => {
         if (newArrayItem.dataset.jsPinnedJobItem === pinnedJobId) {
            jobItemBorderClasses(newArrayItem, orderSetting, totalItems);
            orderSetting++;
            return;
         }
      });
   });
   if (pinnedJobs.length === 0) {
      noPinnedJobsSection.classList.remove('hidden');
   }
};

export default setPinnedJobsSection;